import React from 'react'

const FullscreenSpinner = () => {
  return <div className="text-center min-h-screen relative">
    <i className="loading-icon loading-icon--lg absolute" style={{top: 'calc(50% - 2rem)'}}></i>
  </div>
}

export default FullscreenSpinner
